export default "__VITE_ASSET__BeCdGBbH__"